import { WebAppState } from "web/state/store.web";


export const routeType = (state: WebAppState) => state.navigation.type